export default class VanillaInputFilled {
  constructor(selector = 'input[type="text"], textarea') {
    this.inputs = document.querySelectorAll(selector);
    if (!this.inputs.length) return;
    this.bindEvents();
    this.updateAll();
  }

  bindEvents() {
    this.inputs.forEach((input) => {
      input.addEventListener("input", () => this.toggleClass(input));
      input.addEventListener("change", () => this.toggleClass(input));
      input.addEventListener("blur", () => this.toggleClass(input));
    });
  }

  updateAll() {
    this.inputs.forEach((input) => this.toggleClass(input));
  }

  toggleClass(input) {
    input.classList.toggle("is-filled", input.value.trim() !== "");
  }
}
